// extracted by mini-css-extract-plugin
export default {"ItemsPage":"ItemsPage_ItemsPage__hKY4b"};